import { render, staticRenderFns } from "./ViewInvoicePage.vue?vue&type=template&id=7a52e5e4&"
import script from "./ViewInvoicePage.vue?vue&type=script&lang=js&"
export * from "./ViewInvoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports